var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CardTable',{attrs:{"loading":_vm.loadingAlerts,"header":"Past Alerts","tableHeaders":_vm.headers,"tableData":_vm.pastAlerts.restAlertList}})
}
var staticRenderFns = []

export { render, staticRenderFns }